import React, { useState } from 'react';
import './Contact.scss';
import ThankYou from './ThankYou/ThankYou';

export default function Contact() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [messageSent, setMessageSent] = useState(false);

    const encode = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
    }

    async function handleSubmit(e) {
        e.preventDefault();
        
        if (name === "") {
            document.getElementsByClassName("form-name")[0].classList.add("not-valid");
            document.getElementsByClassName("form-name")[0].placeholder = "*Please enter your name";
            return;
        }
        
        if (!formValidation(email)) {
            document.getElementsByClassName("form-email")[0].classList.add("not-valid");
            document.getElementsByClassName("form-email")[0].placeholder = "*Please enter a valid email";
            return;
        }

        try {
            const response = await fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: encode({ "form-name": "contact", name, email, message })
            });

            if (response.ok) {
                setMessageSent(true);
                
                setName("");
                setEmail("");
                setMessage("");
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was a problem sending your message. Please try again.');
        }
    }

    function formValidation(email) {
        const emailRegEx = /\S+@\S+\.\S+/;
        return emailRegEx.test(email);
    }

    function handleName(e) {
        setName(e.target.value);
        
        if (e.target.classList.contains("not-valid")) {
            e.target.classList.remove("not-valid");
            e.target.placeholder = "Name";
        }
    }

    function handleEmail(e) {
        setEmail(e.target.value);
        
        if (e.target.classList.contains("not-valid")) {
            e.target.classList.remove("not-valid");
            e.target.placeholder = "Email";
        }
    }

    function handleMessage(e) {
        setMessage(e.target.value);
    }

    return (
        <div id="contact" className="contact">
                <>
                    <h1>Let's Talk!</h1>
            {messageSent ? (
                <ThankYou />
            ) : (<form name="contact" className="contact-form" onSubmit={handleSubmit}>
                        <div className="contact-field">
                            <input 
                                type="text" 
                                name="name" 
                                placeholder="Name" 
                                className="form-name" 
                                value={name} 
                                onChange={handleName} 
                            />
                        </div>
                        <div className="contact-field">
                            <input 
                                type="email" 
                                name="email" 
                                placeholder="Email" 
                                className="form-email" 
                                value={email} 
                                onChange={handleEmail} 
                            />
                        </div>
                        <div className="contact-field">
                            <textarea 
                                name="message" 
                                placeholder="Your message" 
                                className="form-text" 
                                value={message} 
                                onChange={handleMessage}
                            ></textarea>
                        </div>
                        <button type="submit" className="form-submit-btn">Send</button>
                    </form>)}
                </>
        </div>
    );
}

